import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useModalStore } from '@/hooks/useModalStore'
import { APP_NAME, SYSTEM_VERSION } from '@/config/appInfo'
import { Dialog } from '@/components/ui/Dialog'
import { Button } from '@/components/ui/Button'

const SUPPORT_EMAIL = 'suporte@morpher.com'

export function Footer() {
  const { t } = useTranslation()
  const openAbout = useModalStore((state) => state.openAbout)
  const [supportOpen, setSupportOpen] = useState(false)
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')

  const openEmail = () => {
    const query = new URLSearchParams({ subject: subject.trim(), body: message.trim() })
    window.location.href = `mailto:${SUPPORT_EMAIL}?${query.toString()}`
    setSupportOpen(false)
  }

  return (
    <footer
      className="flex items-center px-3 text-[10px] shrink-0 h-7"
      style={{
        background: 'var(--bg-toolbar)',
        borderTop: '1px solid var(--border)',
        color: 'var(--text-dim)',
      }}
    >
      <div className="flex items-center gap-2">
        <span>{t('footer.developedBy')}</span>
        <button className="hover:underline" style={{ color: 'var(--text-muted)' }} onClick={openAbout}>
          {APP_NAME}
        </button>
        <span>·</span>
        <span>v{SYSTEM_VERSION}</span>
      </div>
      <button type="button" className="ml-auto hover:underline" style={{ color: 'var(--text-muted)' }} onClick={() => setSupportOpen(true)}>
        Precisa de ajuda? Fale com o suporte
      </button>
      <Dialog open={supportOpen} title="Falar com o suporte" onClose={() => setSupportOpen(false)} footer={<><Button onClick={() => setSupportOpen(false)}>Cancelar</Button><Button variant="primary" disabled={!subject.trim() || !message.trim()} onClick={openEmail}>Preparar e-mail</Button></>}>
        <p className="mb-4 text-xs leading-5" style={{ color: 'var(--text-muted)' }}>Conte o que aconteceu. Vamos preparar uma mensagem para <strong>{SUPPORT_EMAIL}</strong> no seu aplicativo de e-mail.</p>
        <label className="block text-xs font-medium">Assunto<input className="mt-1 h-9 w-full rounded-md border px-3 text-xs outline-none" style={{ background: 'var(--bg-input)', borderColor: 'var(--border)', color: 'var(--text)' }} value={subject} maxLength={160} onChange={(event) => setSubject(event.target.value)} placeholder="Como podemos ajudar?" /></label>
        <label className="mt-3 block text-xs font-medium">Mensagem<textarea className="mt-1 min-h-32 w-full rounded-md border p-3 text-xs outline-none" style={{ background: 'var(--bg-input)', borderColor: 'var(--border)', color: 'var(--text)' }} value={message} onChange={(event) => setMessage(event.target.value)} placeholder="Descreva o problema ou a sua dúvida…" /></label>
      </Dialog>
    </footer>
  )
}
